mutation CreateSmsDripSequence($input: SmsDripSequenceCreateInput!) {
    smsDripSequenceCreate(input: $input) {
        dripSequence {
            id
            name
            htmlUrl
            htmlUrlPath
        }
    }
}
